module.exports = __webpack_public_path__ + "static/media/DSC_8071.d097ba4a.jpg";